import { render, staticRenderFns } from "./purchuseListcart.vue?vue&type=template&id=2addca16&"
import script from "./purchuseListcart.vue?vue&type=script&lang=js&"
export * from "./purchuseListcart.vue?vue&type=script&lang=js&"
import style0 from "./purchuseListcart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports